import { useCallback, useMemo, useRef } from 'react';
import { triggerImpactHaptic } from '../utils/hapticFeedback';

const HAPTIC_DEDUPE_MS = 80;

export function useHapticPress(fallbackWebApp = null, style = 'light') {
  const lastHapticAtRef = useRef(0);

  const triggerHaptic = useCallback(() => {
    const now = Date.now();
    if (now - lastHapticAtRef.current < HAPTIC_DEDUPE_MS) {
      return;
    }

    lastHapticAtRef.current = now;
    triggerImpactHaptic(style, fallbackWebApp);
  }, [fallbackWebApp, style]);

  const handleKeyDown = useCallback(
    (event) => {
      if (event.repeat) return;

      if (event.key === 'Enter' || event.key === ' ') {
        triggerHaptic();
      }
    },
    [triggerHaptic]
  );

  return useMemo(
    () => ({
      onPointerDownCapture: triggerHaptic,
      onTouchStartCapture: triggerHaptic,
      onMouseDownCapture: triggerHaptic,
      onKeyDown: handleKeyDown,
    }),
    [handleKeyDown, triggerHaptic]
  );
}
